// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { includes } = require('lodash/collection');
// Commons components
const { OKIconTask } = require('commonsComponents/OKIconTask');

const RetailLoanArrow = ({ className, onClick, icon }) => {
    const disabled = includes(className, "slick-disabled");
    const classNameArrows = classnames(className, "retail-loan-carousel__container-arrows");
    return !disabled ? (
        <div className={classNameArrows} >
            <OKIconTask icon={icon} type="circle" style="default" onClick={onClick} />
        </div>
    ) : null;
};

RetailLoanArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.string.isRequired
};

module.exports = RetailLoanArrow;
